<template>
     <div class="second_plate">
        <div class="nav-header">
            <van-nav-bar 
                :title="secondInfoObj.name"
                @click-left="leftFn"
                left-arrow/>
        </div>
        <div class="content_detail">
             <first-stepother
                :branchList='secondBranchList'
                :showFirstContent='showFirstContent'/>
        </div>
        <div class="nodata_area" v-if="dataExit && !loadings">
            <no-datas
                :dataExit='dataExit'/>
        </div>
        <div class="loading_area" v-if="loadings">
            <loading></loading>
        </div>
    </div>
</template>

<script>
import { getRequest } from '@/assets/js/api'
import FirstStepother from '@/components/parent-course/first-step-other.vue'
import NoDatas from '@/components/common/no-datas.vue'
import {verticalScreen} from '@/assets/js/vertical-screen';
import Loading from '@/components/common/is-loading' 
export default {
  name: 'second-plate',
  components: {FirstStepother, NoDatas, Loading},
  props: {},
  data() {
    return {
        secondBranchList: [],
        secondInfoObj:{},
        showFirstContent:true,
        dataExit: false,
        loadings: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
     // 根据id获取栏目下的内容
    async getColumnBranch(id) {
        this.loadings = true
        try {
            getRequest(`/api-content/column/branches/` + id + '?code=JZ').then(res => {
                this.loadings = false
                let { code, message, data } = res
                if(res && code === 200) {
                    if(data && data.length > 0) {
                        this.dataExit = false
                        this.secondBranchList = data
                    } else {
                        // 没数据，缺省图
                        this.dataExit = true
                        this.secondBranchList = []
                        this.showFirstContent = false
                    }
                } else {
                    this.dataExit = true
                    this.secondBranchList = []
                    this.showFirstContent = false
                    // 没数据，缺省图
                    Toast(message)
                }
            })
        } catch (error) {
             this.loadings = false
        }
    },
    leftFn() {
        this.$router.back()
    }
  },
  beforeCreate() {},
  created() {
    this.secondInfoObj = this.$storage.getStore('firstPlateInfo')
    this.getColumnBranch(this.secondInfoObj.id)
    
},
  beforeMount() {},
  mounted() {
    verticalScreen();
},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.second_plate {
    .nav-header {
        .van-nav-bar.van-hairline--bottom {
            position: fixed;
            width: 100%;
        }
    }
     height: 100%;
    .content_detail {
        padding-top: 35px;
        display: flex;
        justify-content: center;
    }
    .nodata_area {
        width: 100%;
        height: 80%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .loading_area {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
